import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaRobot, FaMagic, FaBolt } from 'react-icons/fa';
import ToolSection from '../components/ToolSection';


// Slider görselleri
import slide1 from '../images/slider1.png';
import slide2 from '../images/slider2.png';
import video from '../images/video.mp4'

// Neue Service Images (platzhalter)
import service1 from '../images/sah.png';
import service2 from '../images/design.png';
import service3 from '../images/develop.png';
import service4 from '../images/marketing.png';


const slides = [
  {
    image: slide1,
    title: 'Smart Webentwicklung ',
    subtitle: 'Wir entwickeln die Zukunft deiner Marke.',
    buttonText: 'Angebot Einholen',
    buttonLink: '/angebot-form',
  },
  {
    image: slide2,
    title: 'Tech. Design. Strategie. ',
    subtitle: 'Digitale Produkte, Apps & KI-Lösungen für Unternehmen ',
    buttonText: 'Lass uns sprechen',
    buttonLink: '/lass-sprechen',
  },
];
const sliderImages = [slide1, slide2];

const HomePage = () => {
  const [sliderIndex, setSliderIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSliderIndex((prev) => (prev + 1) % sliderImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-black text-white font-sans">
      {/* SLIDER SECTION */}
      <section className="relative h-[80vh] md:h-[100vh] w-full overflow-hidden">
        <div className="absolute inset-0 transition-opacity duration-1000 ease-in-out">
          <img
            src={slides[sliderIndex].image}
            alt="Slider"
            className="object-cover w-full h-full brightness-[.7] scale-100 md:scale-105 transition duration-1000"
          />
        </div>


        {/* İçerik sağ altta */}
        <div className="absolute inset-0 flex items-end justify-end px-6 md:px-16 pb-5">
          <div className="text-right animate-fade-up space-y-4 max-w-xl">
            <h1 className="text-4xl md:text-6xl font-extrabold text-white drop-shadow-xl leading-tight">
              {slides[sliderIndex].title.split('Net Moove')[0]}
              <span className="text-fuchsia-500"> Net Moove</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-200 italic drop-shadow">
              {slides[sliderIndex].subtitle}
            </p>
            <Link
              to={slides[sliderIndex].buttonLink}
              className="inline-block bg-gradient-to-r from-purple-600 to-pink-500 hover:from-pink-500 hover:to-purple-600 text-white px-6 py-3 rounded-full no-underline font-semibold shadow-lg hover:scale-105 transition"
            >
              {slides[sliderIndex].buttonText}
            </Link>
          </div>
        </div>
      </section>

      {/* Giris Seo & Vizyon */}
      <section className="bg-black text-white py-20 px-6 md:px-20">
        <div className="max-w-6xl mx-auto space-y-12">
          <div className="text-center space-y-6">
            <h2 className="text-3xl md:text-6xl font-extrabold text-gray-200 leading-tight">
              Technologie, die für dich denkt
              <span className="text-fuchsia-500">.</span>

            </h2>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
              Ob KI-Integration, smartes Shopsystem oder eine mutige App-Idee: Wir helfen Vordenkern,
              Startups und Unternehmen, aus Technologie echte Erlebnisse zu machen – intuitiv, skalierbar, menschlich.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 text-left">
            <div className="space-y-2">
              <h3 className="text-2xl font-bold text-[#c1ff72]">KI & Automation</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Automatisierte Workflows, GPT-gestützte Systeme & maßgeschneiderte AI-Logik für reale Probleme.
              </p>
            </div>
            <div className="space-y-2">
              <h3 className="text-2xl font-bold text-[#c1ff72]">E-Commerce & SaaS</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Smarte Shopsysteme, Headless-Commerce & SaaS-Backends für ambitionierte Projekte.
              </p>
            </div>
            <div className="space-y-2">
              <h3 className="text-2xl font-bold text-[#c1ff72]">Ideen in Produkte verwandeln</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Von der Skizze zum skalierbaren Produkt. MVPs, UX-Prototyping, Testing und Launch – alles aus einer Hand.
              </p>
            </div>
          </div>

          <div className="mt-16 border-l-4 border-fuchsia-500 pl-6 text-left max-w-2xl mx-auto">
            <p className="italic text-gray-400 text-md leading-relaxed">
              "Technologie ist nur dann wertvoll, wenn sie dem Menschen dient."
            </p>
            <p className="text-sm text-gray-500 mt-1 font-light">– Steve Jobs</p>
          </div>
        </div>
      </section>


      {/* ZIGZAG SERVICE SECTION */}
      {/* ZIGZAG SERVICE SECTION */}
      <section className="py-16 px-6 md:px-16 bg-black">
        <h2 className="text-4xl md:text-5xl font-extrabold text-white text-center mb-24">
          Was wir alles für euch tun können
        </h2>

        <div className="flex flex-col gap-16 md:gap-32 relative max-w-7xl mx-auto">
          {[
            {
              title: 'Strategie & Beratung',
              text: `Wir analysieren dein Geschäftsmodell detailliert und entwickeln eine maßgeschneiderte Digitalstrategie. Von Zielgruppenanalyse bis zur Roadmap bieten wir ganzheitliche Beratung, die dein Wachstum nachhaltig fördert.`,
              img: service1,
            },
            {
              title: 'Design',
              text: `Unser Design-Team verbindet Ästhetik mit Funktionalität. Ob Branding, UI/UX oder animierte Prototypen – wir schaffen benutzerfreundliche und wirkungsvolle digitale Erlebnisse, die deine Marke stärken.`,
              img: service2,
            },
            {
              title: 'Entwicklung',
              text: `Wir entwickeln performante, skalierbare Web-Apps, Shops und Plattformen mit modernster Technologie. Zusätzlich integrieren wir KI-Lösungen, die dein Geschäftsmodell zukunftssicher machen.`,
              img: service3,
            },
            {
              title: 'Online Marketing',
              text: `Mit gezielten SEO-Strategien, datenbasierten Ads und aktivem Social Media Management erhöhen wir deine Reichweite effektiv. So erreichst du deine Zielgruppe genau dort, wo sie aktiv ist.`,
              img: service4,
            },
          ].map((item, index, arr) => (
            <div
              key={index}
              className={`flex flex-col md:flex-row items-center gap-5 ${index % 2 === 1 ? 'md:flex-row-reverse' : ''}`}
            >
              {/* Bild mit einheitlicher Größe */}
              <div className="md:w-1/2 flex justify-center">
                <img
                  src={item.img}
                  alt={item.title}
                  className="rounded-2xl transition-transform duration-500 hover:scale-105 hover:rotate-[1deg] shadow-lg max-h-64 w-auto object-contain"
                />
              </div>

              {/* Textblock */}
              <div className="md:w-1/2 space-y-4 text-left">
                <h3 className="text-2xl md:text-3xl font-bold" style={{ color: '#c1ff72' }}>
                  {item.title}
                </h3>
                <p className="text-gray-300 leading-relaxed text-base md:text-lg">{item.text}</p>
              </div>

              {/* Pfeil nach unten (außer beim letzten Element) */}
              {index < arr.length - 1 && (
                <div className="w-full flex justify-center mt-12">
                  <div className="text-3xl text-fuchsia-500 animate-bounce">↓</div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-24 md:mt-32">
          <Link
            to="/lass-sprechen"
            className="inline-block bg-gradient-to-r from-fuchsia-600 to-pink-500 text-white px-6 py-3 rounded-full no-underline font-semibold hover:scale-105 transition"
          >
            Starte dein Projekt mit uns
          </Link>
        </div>
      </section>


      {/* All-in-One Section */}
      <section className="text-center py-16 bg-black px-6">
        <div className="max-w-5xl mx-auto space-y-8">
          <h3 className="text-2xl md:text-4xl font-semibold text-white animate-pulse">
            Digital ist nicht die Zukunft. Digital ist jetzt.
          </h3>
          <p className="text-gray-300 text-lg">
            In einer Welt, in der sich Technologien rasant entwickeln, ist Digitalisierung kein Zukunftsversprechen mehr – sie ist längst Realität. Wer heute nicht digital denkt, verpasst die Chancen von morgen.
          </p>
          <p className="text-gray-300 text-lg">
            <strong>Netmoove</strong> begleitet Unternehmen mit <strong>maßgeschneiderter Web- & App-Entwicklung</strong>, innovativem <strong>Design</strong>, kluger <strong>Strategie</strong> und wirkungsvollem <strong>Online-Marketing</strong>. Wir schaffen digitale Lösungen, die begeistern und wachsen.
          </p>

          <div className="grid md:grid-cols-2 gap-6 text-left text-gray-200 text-base max-w-4xl mx-auto">
            <ul className="space-y-2 list-disc list-inside">
              <li><strong>Web- & App-Entwicklung:</strong> Von der Idee bis zum Launch – schnell, modern und skalierbar.</li>
              <li><strong>Design & UX:</strong> Ästhetisch, funktional und nutzerzentriert.</li>
            </ul>
            <ul className="space-y-2 list-disc list-inside">
              <li><strong>Strategie & Planung:</strong> Individuelle digitale Roadmaps für Ihren Erfolg.</li>
              <li><strong>Online-Marketing:</strong> SEO, Social Media & Performance – gezielt sichtbar werden.</li>
            </ul>
          </div>

          <p className="text-gray-300 text-lg">
            Wir denken digital – kreativ, strategisch und zielgerichtet.
          </p>
          <p className="text-white text-xl font-semibold">
            Denn digital ist nicht irgendwann. <span className="text-fuchsia-500">Digital ist jetzt.</span>
          </p>

          <a
            href="/lass-sprechen"
            className="inline-block mt-6 bg-fuchsia-600 hover:bg-fuchsia-700 text-white no-underline font-semibold px-6 py-3 rounded-full transition"
          >
            Jetzt unverbindlich sprechen
          </a>
        </div>
      </section>


      <section className="relative w-full overflow-hidden">
        {/* VIDEO HINTERGRUND */}
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover"
        >
          <source src={video} type="video/mp4" />
          Dein Browser unterstützt kein HTML5 Video.
        </video>

        {/* OVERLAY für lesbaren Text */}
        <div className="relative z-10 bg-black/40 backdrop-blur-sm py-24 px-6 md:px-20">
          <h2 className="text-4l md:text-6l font-bold uppercase tracking-wide text-white drop-shadow-[0_0_20px_#ffffffaa] mb-16">
            WARUM <span className="text-[#c1ff72]">WIR</span>
          </h2>

          <div className="grid md:grid-cols-3 gap-12 max-w-7xl mx-auto">
            {/* Card 1 */}
            <div className="text-left text-white space-y-3">
              <FaRobot className="text-[#c1ff72] text-3xl mb-1" />
              <h3 className="text-xl font-semibold">Technologie mit Sinn</h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Technologie ist nur dann sinnvoll, wenn sie den Menschen dient. Unsere Lösungen sind intuitiv und menschenzentriert.
              </p>
            </div>

            {/* Card 2 */}
            <div className="text-left text-white space-y-3">
              <FaMagic className="text-[#c1ff72] text-3xl mb-1" />
              <h3 className="text-xl font-semibold">Erlebnisse statt Webseiten</h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Wir designen keine Layouts – wir schaffen digitale Erlebnisse, die Marken spürbar machen und Menschen bewegen.
              </p>
            </div>

            {/* Card 3 */}
            <div className="text-left text-white space-y-3">
              <FaBolt className="text-[#c1ff72] text-3xl mb-1" />
              <h3 className="text-xl font-semibold">Strategie trifft Design</h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Klarheit, Einfachheit, Wirkung: Unsere Projekte transformieren – mit Substanz, nicht mit Buzzwords.
              </p>
            </div>
          </div>
        </div>
      </section>



      <ToolSection />


      {/*Kapanis SEO METNI ve CTA */}
      <section className="bg-black text-white px-6 md:px-20 py-4 text-center">
        <div className="max-w-5xl mx-auto space-y-8">
          <p className="text-lg md:text-lg text-gray-400 leading-relaxed">
            Wir beraten Startups, die digitale Produkte bauen wollen – und Unternehmen,
            die ihre Systeme modernisieren oder neue Services entwickeln möchten.
          </p>


          <p className="text-lg md:text-lg text-gray-400 leading-relaxed">
            Ob Webentwicklung, App-Konzeption oder KI-gestützte Plattformen:
            Wir liefern Lösungen, die skalieren, sich in reale Prozesse integrieren lassen und echte Nutzer überzeugen.
          </p>

          <p className="text-lg md:text-lg text-gray-400 leading-relaxed">
            Unser Team kombiniert Design, Technologie und Strategie zu digitalen Produkten,
            die nicht nur modern aussehen – sondern nachhaltig funktionieren.
          </p>

          <p className="text-white text-xl font-semibold">
            Lass uns unverbindlich über deine Idee sprechen.
          </p>

          <a
            href="/lass-sprechen"
            className="inline-block mt-6 bg-gradient-to-r from-fuchsia-600 to-pink-500 hover:from-pink-500 hover:to-fuchsia-600 text-white font-semibold px-8 py-3 rounded-full no-underline transition duration-300 hover:scale-105"
          >
            Jetzt kostenloses Erstgespräch buchen
          </a>
        </div>
      </section>

    </div>
  );
};

export default HomePage;
